const initState = {
    detailedReportData: [],
    fetching: false,
    pastCommunications: [],
    posting: false,
    selectedCommunication: null,
    summaryReportData: []
};

export default initState;
